module.exports = __webpack_public_path__ + "static/media/allowDropNavy2.17a8b157.svg";